module.exports = __webpack_public_path__ + "img/v.2d6d98c1.png";